export * from './auth.service';


// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/services/auth/index.ts